module.exports = __webpack_public_path__ + "img/32.1.13ae21de.jpg";